export default {
  state: {
    paytype: '',
    memberpaytype: '',
    // 是否弹出选择花呗分期的提示框
    is_select_hbfqnum: false,
    // 默认花呗分期数
    hbfq_num: 6
  }
}



// WEBPACK FOOTER //
// ./src/store/pay.js